module.exports = __webpack_public_path__ + "img/Hut.e3e6bbdb.jpg";